/**
 * Service to load script resources
 */
class Script {
  /**
   * Fetches a single script
   *
   * @param {string} url The URL of the script to fetch
   * @param {boolean} async
   * @param {boolean} crossorigin
   * @return {Promise}
   */
  fetch(url, async = true, crossorigin = false) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.onload = resolve;
      script.onerror = reject;
      script.async = async;
      if (crossorigin) {
        script.setAttribute('crossorigin', '');
      }
      script.src = url;
      document.body.appendChild(script);
    });
  }

  /**
   * Fetches multiple scripts in parallel
   *
   * @param {Array<string>} urls The list of URLs to fetch
   * @param {boolean} async
   * @param {boolean} crossorigin
   * @return {Promise}
   */
  fetchAll(urls, async = true, crossorigin = false) {
    if (!Array.isArray(urls)) {
      return null;
    }

    return Promise.all(urls.map(url => this.fetch(url, async, crossorigin)));
  }
}

export default new Script();
